const SET_LOADER = 'SET_LOADER';

export const setLoader = (isLoading) => (dispatch) => {
    dispatch({
        type: SET_LOADER,
        isLoading,
    });
};

const initialState = {
    isLoading: false,
};

export const HistoriqueLoaderReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_LOADER:
            return { isLoading: action.isLoading };
        default:
            return state;
    }
};
